"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1000 600",
  "enable-background": "new 0 0 1000 1000",
  xmlSpace: "preserve",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "100",
      y: "300",
      width: "80",
      height: "200"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "220",
      y: "200",
      width: "80",
      height: "300"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "340",
      y: "150",
      width: "80",
      height: "350"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "460",
      y: "100",
      width: "80",
      height: "400"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "580",
      y: "250",
      width: "80",
      height: "250"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "700",
      y: "180",
      width: "80",
      height: "320"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "820",
      y: "280",
      width: "80",
      height: "220"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
    x1: "50",
    y1: "500",
    x2: "950",
    y2: "500",
    width: "40"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
    x1: "100",
    y1: "50",
    x2: "100",
    y2: "500",
    width: "40"
  })]
}));